module.exports = __webpack_public_path__ + "img/Logo_RGB.928a734e.png";